import { Link, useRouterState } from '@tanstack/react-router';
import { useAuthStore } from '../store/auth.ts';
import { Icon } from './Icon.tsx';
import { dv } from '../i18n/dv.ts';

type NavItem = { to: string; label: string; icon: string; matchPrefix?: string };

export function BottomNav(): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (!user) return null;
  const items: NavItem[] = [
    { to: '/', label: dv.nav.dashboard, icon: 'dashboard' },
    { to: '/letters', label: dv.nav.letters, icon: 'description', matchPrefix: '/letters' },
    ...(user.isOrgAdmin ? [{ to: '/settings', label: dv.nav.settings, icon: 'tune', matchPrefix: '/settings' }] : []),
    { to: '/profile', label: dv.nav.profile, icon: 'person' },
  ];

  return (
    <nav
      aria-label={dv.nav.dashboard}
      className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-[hsl(var(--chrome))]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="flex items-stretch">
        {items.map((item) => {
          const active = item.matchPrefix ? pathname.startsWith(item.matchPrefix) : pathname === item.to;
          return (
            <li key={item.to} className="flex-1">
              <Link
                to={item.to}
                aria-label={item.label}
                aria-current={active ? 'page' : undefined}
                className="flex h-14 w-full flex-col items-center justify-center gap-1 active:scale-95 transition-transform"
              >
                <span className="relative inline-flex items-center justify-center">
                  <span
                    className={[
                      'inline-flex items-center justify-center rounded-full px-4 py-0.5 transition-colors',
                      active ? 'bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))]' : 'text-muted-foreground',
                    ].join(' ')}
                  >
                    <Icon name={item.icon} size={22} fill={active} />
                  </span>
                </span>
                <span className={active ? 'text-[11px] leading-none text-ink font-medium' : 'text-[10.5px] leading-none text-muted-foreground'}>
                  {item.label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
